import {
  ArticleSectionTabCount,
  ArticleSectionTabLabel,
  ArticleSectionTabLink,
  ArticleSectionTabState,
} from '@vs-shop/commerce-ui/articleSectionTabs';

type Props = {
  href: string;
  // oxlint-disable-next-line vspoint-effect/branded-component-props -- mixed display string: callers pass both branded `section.name` (coalesced with '') and plain intl strings ('Vše')
  name: string;
  articlesCount: number;
  isSelected: boolean;
};

export default function ArticlesSectionLink({ href, name, articlesCount, isSelected }: Props) {
  const state = isSelected ? ArticleSectionTabState.SELECTED : ArticleSectionTabState.AVAILABLE;

  return (
    <ArticleSectionTabLink
      href={href}
      aria-current={isSelected ? 'page' : undefined}
      data-selected={isSelected ? 'true' : 'false'}
    >
      <ArticleSectionTabLabel state={state}>{name}</ArticleSectionTabLabel>
      <ArticleSectionTabCount state={state}>{articlesCount}</ArticleSectionTabCount>
    </ArticleSectionTabLink>
  );
}
